export default __webpack_public_path__ + "static/media/875.0021283c.gif";